import React from "react";
import { motion } from "framer-motion";
import { AlertCircle, CheckCircle, Info, AlertTriangle } from "lucide-react";
import { STATUS } from "../../data/statusColors";
import { useTranslate } from "../../i18n/useTranslate";

const BUCKET_BY_TYPE = { danger: "critical", warning: "warning", info: "info", success: "good" };
const ICON_BY_TYPE = { danger: AlertCircle, warning: AlertTriangle, info: Info, success: CheckCircle };

const typeConfig = Object.fromEntries(
  Object.entries(BUCKET_BY_TYPE).map(([type, bucket]) => [
    type,
    { icon: ICON_BY_TYPE[type], bg: STATUS[bucket].bg, text: STATUS[bucket].text, hex: STATUS[bucket].hex },
  ])
);

export default function IncidentFeed({ alerts, limit = 6 }) {
  const t = useTranslate();
  return (
    <div className="space-y-2">
      {alerts.slice(0, limit).map((alert, i) => {
        const c = typeConfig[alert.type] || typeConfig.info;
        const Icon = c.icon;
        return (
          <motion.div
            key={alert.id}
            initial={{ opacity: 0, x: -12 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: i * 0.06 }}
            style={{ borderLeftColor: c.hex }}
            className="flex items-start gap-3 p-3 rounded-xl bg-white border border-slate-100 border-l-4 hover:shadow-sm transition-shadow cursor-pointer"
          >
            <div className={`w-7 h-7 rounded-lg ${c.bg} flex items-center justify-center flex-shrink-0`}>
              <Icon size={14} className={c.text} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs font-semibold text-slate-800 leading-snug truncate">{t(alert.title)}</p>
              <div className="flex items-center gap-2 mt-0.5">
                <span className="text-[11px] text-slate-400">{t(alert.time)}</span>
                <span className="text-[11px] text-slate-300">•</span>
                <span className="text-[11px] text-slate-500">{t(alert.dept)}</span>
              </div>
            </div>
            <span className={`text-[9px] font-black uppercase px-1.5 py-0.5 rounded-full ${c.bg} ${c.text} flex-shrink-0`}>
              {t(alert.priority)}
            </span>
          </motion.div>
        );
      })}
    </div>
  );
}
